import { useQuery } from '@tanstack/react-query';
import { extractBackendErrorCode } from '@/core/api/http-errors';
import { formsService } from '../api/forms.service';
import { FORM_KEYS } from './queryKeys';

/** Reads a shared, `Public`-audience form with no auth/tenant context. */
export function usePublicForm(formId: string) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: FORM_KEYS.public(formId),
    queryFn: ({ signal }) => formsService.getPublicById(formId, signal),
    staleTime: 300_000,
    enabled: !!formId,
    retry: 1,
  });

  return {
    form: data?.data,
    isLoading,
    isError,
    errorCode: isError ? extractBackendErrorCode(error) : null,
  };
}
